import React, { useEffect } from 'react';
import Settings from './Settings';

function SettingsDropdown(props) {
    useEffect(() => {
        function handler(e) {
            if (e.target.closest('#settings-dropdown-1') == null) {
                props.toggle();
            }
        }
        window.addEventListener('click', handler);
        
        return () => {
            window.removeEventListener('click', handler);
        };
    });

    return (
        <div id="settings-dropdown-1" style={props.style} className="container-carrello-mobile_intestazione_settings-dropdown">
            <div className="d-flex align-items-center justify-content-start">
                <div className="nav-slider-menu-close-button push-right" onClick={props.toggle}>
                    <i className="fa fa-times"></i>
                </div>
            </div>
            <Settings />
        </div>
    );
}

export default SettingsDropdown;